import { render } from "./EditPerformanceTracker.vue?vue&type=template&id=5101576e"
import script from "./EditPerformanceTracker.vue?vue&type=script&lang=js"
export * from "./EditPerformanceTracker.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__